var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6H6V12H12V6ZM10 10H8V8H10V10ZM18 8V6H16V4C16 2.9 15.1 2 14 2H12V0H10V2H8V0H6V2H4C2.9 2 2 2.9 2 4V6H0V8H2V10H0V12H2V14C2 15.1 2.9 16 4 16H6V18H8V16H10V18H12V16H14C15.1 16 16 15.1 16 14V12H18V10H16V8H18ZM14 14H4V4H14V14Z",
    fill: "#3367CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.14c99f80.svg";
export { ForwardRef as ReactComponent };